export const radioButtonStyles = {
  "& .MuiTypography-root": {
    fontSize: "12px",
    color: "#212121 !important",
  },
  "& .MuiRadio-root ": {
    p: "8px",
  },
  "& .Mui-checked": {
    color: "#DB154D !important",
  },
};
